import styled from "styled-components"
import Text from "../../atoms/Text";
import ClearableInput from "../ClearableInput";
import MainButton from "../../atoms/MainButton";
import { validateEmail } from "../../../utils/userValidation";

const Container = styled.div`
  position: relative;
  width: 100%;
  min-height: 50px;
`;
const LabelWrapper = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 4px;
`
const RequiredCircle = styled.div`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.status.error};
`
const InputWrapper = styled.div`
  display: flex;
  gap: 8px;
`

const EmailAuthInput = ({placeholder, value, onChange, required=false, buttonLabel, onSendEmail, $error, ...props}) => {
  return (
    <Container>
      <label>
        <LabelWrapper>
          <Text as="label" variant="body2" weight="medium">이메일 인증</Text>
          {required && <RequiredCircle aria-label="필수 입력 항목"/>}
        </LabelWrapper>
        <InputWrapper>
          <ClearableInput 
            placeholder={placeholder} 
            value={value} 
            onChange={onChange}
            $error={$error}
            {...props}/>
          <MainButton 
            title={buttonLabel}
            $compact={true}
            $fullWidth={false}
            disabled={!validateEmail(value)}
            onClick={onSendEmail}
            type="button"/>
        </InputWrapper>
      </label>
    </Container>
  )
}

export default EmailAuthInput
